import './store-badges.scss';
import BadgeGooglePt from '../../../../common/assets/svg/google-play/download_google_play_PT_BR.svg';
import BadgeGoogleEn from '../../../../common/assets/svg/google-play/download_google_play_EN_US.svg';
import BadgeGoogleEs from '../../../../common/assets/svg/google-play/download_google_play_ES_ES.svg';
import BadgeApplePt from '../../../../common/assets/svg/app-store/download_app_store_PT_BR.svg';
import BadgeAppleEn from '../../../../common/assets/svg/app-store/download_app_store_EN_US.svg';
import BadgeAppleEs from '../../../../common/assets/svg/app-store/download_app_store_ES_ES.svg';
import { Language } from '../../../../common/constants/languages';

const getBadge = (
    currentLanguage: Language,
    badgeMap: Record<Language, string>,
    defaultBadge: string,
    className: string,
) => {
    const badgeSrc = badgeMap[currentLanguage] || defaultBadge;

    return <img src={badgeSrc} alt="Badge" className={className} />;
};

export const GetGoogleBadge = ({
    currentLanguage,
}: {
    currentLanguage: Language;
}) => {
    const badgeMap = {
        'pt-BR': BadgeGooglePt,
        'en-US': BadgeGoogleEn,
        'es-ES': BadgeGoogleEs,
    };

    const defaultBadge = BadgeGoogleEn;

    return getBadge(currentLanguage, badgeMap, defaultBadge, 'badge-google');
};

export const GetAppleBadge = ({
    currentLanguage,
}: {
    currentLanguage: Language;
}) => {
    const badgeMap = {
        'pt-BR': BadgeApplePt,
        'en-US': BadgeAppleEn,
        'es-ES': BadgeAppleEs,
    };

    const defaultBadge = BadgeAppleEn;

    return getBadge(currentLanguage, badgeMap, defaultBadge, 'badge-apple');
};
